import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'Pinel' })(HeaderInner);

export default Header;
